var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 24,
    height: 24,
    fill: "#f969a4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Hospital_2529661",
    transform: "translate(-2 -2.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail_Box",
    "data-name": "Mail Box",
    transform: "translate(6.998 4.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11768",
    "data-name": "Path 11768",
    d: "M18.712,7H17.7a3.632,3.632,0,0,1,.077.77,3.848,3.848,0,1,1-7.7,0A3.632,3.632,0,0,1,10.155,7H9.139A2.232,2.232,0,0,0,7,9.309V23.931a.77.77,0,0,0,.77.77h3.848V19.313a1.539,1.539,0,0,1,1.539-1.539H14.7a1.539,1.539,0,0,1,1.539,1.539V24.7h3.848a.77.77,0,0,0,.77-.77V9.309A2.232,2.232,0,0,0,18.712,7Z",
    transform: "translate(-6.998 -4.7)",
    fill: "#f969a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11771",
    "data-name": "Path 11771",
    d: "M15.078,10.159a3.078,3.078,0,0,0,3.078-3.078,2.817,2.817,0,0,0-.1-.77,3.078,3.078,0,0,0-5.956,0,2.817,2.817,0,0,0-.1.77,3.078,3.078,0,0,0,3.078,3.078ZM13.539,6.311h.77v-.77a.77.77,0,0,1,1.539,0v.77h.77a.77.77,0,0,1,0,1.539h-.77v.77a.77.77,0,0,1-1.539,0v-.77h-.77a.77.77,0,0,1,0-1.539Z",
    transform: "translate(-8.151 -4.011)",
    fill: "#f969a4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    x2: 5.387,
    transform: "translate(4.234 19.624)",
    fill: "none",
    stroke: "#f969a4",
    strokeWidth: 0.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicIcon);
export default __webpack_public_path__ + "static/media/clinic_icon.0c4cade148b666bf1876cb87b9e8c53c.svg";
export { ForwardRef as ReactComponent };